import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const SquareMinusIcon = ({ size, color, deg, }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, color: color, deg: deg },
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("rect", { width: "19", height: "19", x: ".5", y: ".5", fill: "#FFF", stroke: color, rx: "4" }),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("rect", { width: "19", height: "19", x: ".5", y: ".5", fill: "#FFF", stroke: color, rx: "4" }),
            React.createElement("path", { fill: color, d: "M6 11h8a1 1 0 0 0 0-2H6a1 1 0 1 0 0 2z" })))));
export const SquareMinus = iconGenerator(SquareMinusIcon);
//# sourceMappingURL=SquareMinus.js.map